import React from 'react';
import { InputNumber } from '@nackle/paper';
import { getString } from '@nackle/intl-tools';

export default function PointEntry( props ) {
    const { disabled, pointMax, pointMin, onChange, onFocus, value,  } = props;
    return ( 
        <div className='points-container'>
            <div>
                <InputNumber 
                    data-testid='pointEntry'
                    aria-label={ getString( 'mediaLabel' ) }
                    bordered={ false }
                    className='points' 
                    onChange={ onChange } 
                    onFocus={ onFocus }
                    min={ pointMin }
                    max={ pointMax }
                    disabled={ disabled }
                    value={ value } 
                />
            </div>
            <div className='points-label'>
                { getString( 'mediaLabel' ) }
            </div> 
        </div> 
    ); 
}